(() => {
  if (customElements.get('banner-principal')) return;

  class BannerPrincipal extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.controlsUpdateTimer = null;
      this.handlePlayPause = this.handlePlayPause.bind(this);
      this.handleMuteUnmute = this.handleMuteUnmute.bind(this);
      this.handleSlideChange = this.handleSlideChange.bind(this);
      this.handleSlideLink = this.handleSlideLink.bind(this);
    }

    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      const listenerOptions = { signal: this.abortController.signal };
      const carousel = this.querySelector('swiper-carousel');

      if (carousel) {
        carousel.addEventListener('swiper:slide-change', this.handleSlideChange, listenerOptions);
      }

      this.querySelectorAll('.play-pause-btn').forEach((button) => {
        button.addEventListener('click', this.handlePlayPause, listenerOptions);
      });

      this.querySelectorAll('.mute-unmute-btn').forEach((button) => {
        button.addEventListener('click', this.handleMuteUnmute, listenerOptions);
      });

      this.querySelectorAll('.swiper-slide[data-link]').forEach((slide) => {
        slide.addEventListener('click', this.handleSlideLink, listenerOptions);
        slide.style.cursor = 'pointer';
      });

      const firstVideo = this.querySelector('.slide-video');
      if (firstVideo) {
        const playPromise = firstVideo.play();
        if (playPromise && typeof playPromise.then === 'function') {
          const syncControls = () => {
            if (!listenerOptions.signal.aborted) this.updateControlsState();
          };
          playPromise.then(syncControls, syncControls);
        }
      }

      this.updateControlsState();
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }

      if (this.controlsUpdateTimer) {
        window.clearTimeout(this.controlsUpdateTimer);
        this.controlsUpdateTimer = null;
      }
    }

    handleSlideChange() {
      if (this.controlsUpdateTimer) window.clearTimeout(this.controlsUpdateTimer);

      this.controlsUpdateTimer = window.setTimeout(() => {
        this.controlsUpdateTimer = null;
        this.updateControlsState();
      }, 100);
    }

    handlePlayPause(event) {
      event.stopPropagation();
      const button = event.currentTarget;
      const video = button.closest('.video-container')?.querySelector('video');
      if (!video) return;

      if (video.paused) {
        const connectionSignal = this.abortController?.signal;
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(
            () => {
              if (!connectionSignal?.aborted) this.updatePlayPauseButton(button, video.paused);
            },
            () => {
              if (!connectionSignal?.aborted) this.updatePlayPauseButton(button, true);
            }
          );
        } else {
          this.updatePlayPauseButton(button, video.paused);
        }
      } else {
        video.pause();
        this.updatePlayPauseButton(button, true);
      }
    }

    handleMuteUnmute(event) {
      event.stopPropagation();
      const button = event.currentTarget;
      const video = button.closest('.video-container')?.querySelector('video');
      if (!video) return;

      video.muted = !video.muted;
      this.updateMuteButton(button, video.muted);
    }

    handleSlideLink(event) {
      const target = event.target;
      if (
        target instanceof Element &&
        (target.closest('.video-controls') || target.closest('.botao-padrao'))
      ) {
        return;
      }

      const link = event.currentTarget.getAttribute('data-link');
      if (link) window.location.href = link;
    }

    updateControlsState() {
      this.querySelectorAll('.slide-video').forEach((video) => {
        const container = video.closest('.video-container');
        if (!container) return;

        const playPauseButton = container.querySelector('.play-pause-btn');
        const muteUnmuteButton = container.querySelector('.mute-unmute-btn');
        this.updatePlayPauseButton(playPauseButton, video.paused);
        this.updateMuteButton(muteUnmuteButton, video.muted);
      });
    }

    updatePlayPauseButton(button, isPaused) {
      if (!button) return;

      const pauseIcon = button.querySelector('.pause-icon');
      const playIcon = button.querySelector('.play-icon');
      if (!pauseIcon || !playIcon) return;

      pauseIcon.style.display = isPaused ? 'none' : 'block';
      playIcon.style.display = isPaused ? 'block' : 'none';
      button.setAttribute('aria-label', isPaused ? 'Reproduzir vídeo' : 'Pausar vídeo');
    }

    updateMuteButton(button, isMuted) {
      if (!button) return;

      const muteIcon = button.querySelector('.mute-icon');
      const unmuteIcon = button.querySelector('.unmute-icon');
      if (!muteIcon || !unmuteIcon) return;

      muteIcon.style.display = isMuted ? 'none' : 'block';
      unmuteIcon.style.display = isMuted ? 'block' : 'none';
      button.setAttribute('aria-label', isMuted ? 'Ativar som' : 'Silenciar vídeo');
    }
  }

  customElements.define('banner-principal', BannerPrincipal);
})();
